import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'pv-sidenav-popup',
  templateUrl: './sidenav-popup.component.html',
  styleUrls: ['./sidenav-popup.component.scss']
})
export class SidenavPopupComponent {
  @Input() cartItem: any;
  @Input() crossSell: any;
  @Output() onClose: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

}
